import React, { useMemo } from 'react'
import { Badge, Modal, ModalHeader, ModalBody, ModalFooter, Button, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import classnames from 'classnames'

const STATUS_META = {
  fechado: { label: 'Fechados', tab: 'sucesso', color: 'success', group: 'sucesso' },
  inserido: { label: 'Inseridos', tab: 'sucesso', color: 'success', group: 'sucesso' },
  pendente: { label: 'Pendentes', tab: 'pendente', color: 'warning', group: 'pendente' },
  sobreposicao: { label: 'Sobreposição', tab: 'pendente', color: 'warning', group: 'pendente' },
  erro: { label: 'Erros', tab: 'erro', color: 'danger', group: 'erro' },
}

const TAB_ORDER = ['sucesso', 'pendente', 'erro']

const TAB_LABELS = {
  sucesso: 'Sucesso',
  pendente: 'Pendências / avisos',
  erro: 'Erros',
}

const RhBulkResultModal = ({
  isOpen,
  toggle,
  title,
  summary,
  detalhes = [],
  activeTab,
  onTabChange,
}) => {
  const grouped = useMemo(() => {
    const groups = { sucesso: [], pendente: [], erro: [] }
    detalhes.forEach(item => {
      const meta = STATUS_META[item.status] || STATUS_META.erro
      groups[meta.group].push(item)
    })
    return groups
  }, [detalhes])

  const defaultTab = useMemo(() => {
    if (grouped.erro.length) return 'erro'
    if (grouped.pendente.length) return 'pendente'
    return 'sucesso'
  }, [grouped])

  const tab = activeTab || defaultTab

  const renderList = (items) => {
    if (!items.length) {
      return <p className="text-muted small mb-0">Nenhum registro nesta categoria.</p>
    }
    return (
      <ul className="list-unstyled mb-0" style={{ maxHeight: 360, overflowY: 'auto' }}>
        {items.map(item => {
          const meta = STATUS_META[item.status] || STATUS_META.erro
          return (
            <li
              key={`${item.pf_id}-${item.status}-${item.nome}`}
              className="py-2 border-bottom"
              style={{ fontSize: '0.85rem' }}
            >
              <div className="d-flex align-items-start justify-content-between" style={{ gap: 8 }}>
                <div className="font-weight-bold">{item.nome || `#${item.pf_id}`}</div>
                <Badge color={meta.color} pill style={{ fontSize: '0.65rem', flexShrink: 0 }}>
                  {meta.label}
                </Badge>
              </div>
              {item.msg && (
                <div className="text-muted small mt-1">{item.msg}</div>
              )}
            </li>
          )
        })}
      </ul>
    )
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" scrollable>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        {summary && (
          <div className="mb-3 p-2 rounded" style={{ background: '#f8f9fa', fontSize: '0.9rem' }}>
            {summary}
          </div>
        )}

        <div className="d-flex flex-wrap mb-3" style={{ gap: 8 }}>
          {TAB_ORDER.map(key => (
            <Badge
              key={key}
              color={key === 'sucesso' ? 'success' : key === 'pendente' ? 'warning' : 'danger'}
              pill
            >
              {TAB_LABELS[key]}
              :
              {' '}
              {grouped[key].length}
            </Badge>
          ))}
        </div>

        <Nav tabs className="nav-tabs-custom mb-3">
          {TAB_ORDER.map(key => (
            <NavItem key={key}>
              <NavLink
                className={classnames({ active: tab === key })}
                onClick={() => onTabChange(key)}
                style={{ cursor: 'pointer' }}
              >
                {TAB_LABELS[key]}
                {' '}
                (
                {grouped[key].length}
                )
              </NavLink>
            </NavItem>
          ))}
        </Nav>

        <TabContent activeTab={tab}>
          {TAB_ORDER.map(key => (
            <TabPane key={key} tabId={key}>
              {renderList(grouped[key])}
            </TabPane>
          ))}
        </TabContent>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggle}>Fechar</Button>
      </ModalFooter>
    </Modal>
  )
}

export default RhBulkResultModal
